var overly = document.querySelector(".quick_add_overlay");
if (overly) {
  overly.addEventListener("click", function () {
    overly.classList.add("hidden");

    const wrap = document.querySelector(".main_quick_add_data_wraper");
    if (wrap) wrap.classList.remove("active");

    document.body.classList.remove("quick_add_open");
  });
}
function hideQuickAdd() {
  var closeQuickAdd = document.querySelectorAll(".hide-quick-add");
  closeQuickAdd.forEach((closebtn) => {
    closebtn.addEventListener("click", function () {
      const overlay = document.querySelector(".quick_add_overlay");
if (overlay) overlay.classList.add("hidden");
      const wrap = document.querySelector(".main_quick_add_data_wraper");
if (wrap) wrap.classList.remove("active");

document.body.classList.remove("quick_add_open");
    });
  });
}

/* === QA Stock Guard (minimal, keeps existing UI) === */
(function () {
  if (window.__QA_STOCK_GUARD__) return;
  window.__QA_STOCK_GUARD__ = true;

  const QA = {
    cartTs: 0,
    qtyMap: new Map(),
    inflight: new Set(),
    CART_CACHE_MS: 2000,

    async fetchCart(force) {
      const now = Date.now();
      if (!force && this.qtyMap.size && (now - this.cartTs) < this.CART_CACHE_MS) {
        return this.qtyMap;
      }
      try {
        const url = '/cart.js?qa_ts=' + Date.now();
        const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!res.ok) throw new Error('cart fetch failed');
        const cart = await res.json();
        const map = new Map();
        if (cart && Array.isArray(cart.items)) {
          cart.items.forEach((it) => {
            if (it && typeof it.variant_id !== 'undefined') {
              map.set(String(it.variant_id), (map.get(String(it.variant_id)) || 0) + (it.quantity || 0));
            }
          });
        }
        this.qtyMap = map;
        this.cartTs = Date.now();
        return this.qtyMap;
      } catch (e) {
        // Don't block user if cart fetch fails
        return this.qtyMap;
      }
    },

    resolveOptionForInput(inputEl) {
      if (!inputEl) return null;
      const mainWrapper = inputEl.closest('.card-wrapper') || inputEl.closest('.main_quick_add_data_wraper') || document;
      const sizeLabel = inputEl.getAttribute('data-label');
      const sizeOptionIndex = parseInt(inputEl.dataset.optionIndex || '0', 10);

      // Try to get selected color inside this card/popup only
      const colorLabel =
        mainWrapper.querySelector('.color_variants:checked')?.getAttribute('data-label') ||
        mainWrapper.querySelector('.color_product_main.active_color')?.getAttribute('data-label') ||
        inputEl?.nextElementSibling?.querySelector('.mobile-bag-text')?.getAttribute('data-name') ||
        mainWrapper.querySelector('.varinats_check_input_color:checked')?.getAttribute('data-label') ||
        mainWrapper.querySelector('.varinats_check_input_color')?.getAttribute('data-label');

      if (!sizeLabel || !colorLabel || !(sizeOptionIndex === 1 || sizeOptionIndex === 2)) return null;

      let matchValue = '';
      if (sizeOptionIndex === 1) matchValue = `${sizeLabel}-${colorLabel}`;
      if (sizeOptionIndex === 2) matchValue = `${colorLabel}-${sizeLabel}`;
      if (!matchValue) return null;

      const variantSelector = mainWrapper.querySelector('.variants_seletor_box');
      if (!variantSelector) return null;

      const allOptions = variantSelector.querySelectorAll('option[data-handels][data-id]');
      if (!allOptions || !allOptions.length) return null;

      // Prefer exact match, then contains match
      let exact = null;
      let fallback = null;
      allOptions.forEach((opt) => {
        const handle = opt.getAttribute('data-handels') || '';
        if (!handle) return;
        if (handle === matchValue) exact = opt;
        if (!fallback && (handle.includes(sizeLabel) && handle.includes(colorLabel))) fallback = opt;
      });
      const option = exact || fallback;
      if (!option) return null;

      const variantId = (option.getAttribute('data-id') || '').trim();
      const stockRaw = (option.getAttribute('data-stock') || '').trim();
      const stock = parseInt(stockRaw, 10);

      if (!variantId) return null;

      return { option, variantId: String(parseInt(variantId, 10)), stock: Number.isFinite(stock) ? stock : null };
    },

    setUnavailable(inputEl, unavailable) {
      const wrapper = inputEl?.closest('.variant_wraper_label');
      if (!wrapper) return;

      if (unavailable) {
        wrapper.classList.add('unavailable_variant');
        wrapper.dataset.qaForcedUnavailable = '1';
        try { inputEl.setAttribute('aria-disabled', 'true'); } catch (e) {}
      } else {
        // Only remove if we previously forced it
        if (wrapper.dataset.qaForcedUnavailable === '1') {
          wrapper.classList.remove('unavailable_variant');
          delete wrapper.dataset.qaForcedUnavailable;
          try { inputEl.removeAttribute('aria-disabled'); } catch (e) {}
        }
      }

      // Mobile popup text handling, keep existing structure as much as possible
      const labelEl = inputEl?.nextElementSibling;
      if (!labelEl) return;

      const mobileBag = labelEl.querySelector('.mobile-bag-text');
      const mblUnavailable = labelEl.querySelector('.mbl-unavailable');

      if (unavailable) {
        if (mobileBag) mobileBag.classList.add('hidden');
        if (!mblUnavailable) {
          const span = document.createElement('span');
          span.className = 'mbl-unavailable';
          span.textContent = 'Out of stock';
          span.dataset.qaInjected = '1';
          labelEl.appendChild(span);
        }
      } else {
        const forced = wrapper.dataset.qaForcedUnavailable === '1';
        // If not forced anymore, restore
        if (!forced) {
          if (mobileBag) mobileBag.classList.remove('hidden');
          if (mblUnavailable && mblUnavailable.textContent.trim().toLowerCase() === 'out of stock') {
            // remove only the one we injected
            if (mblUnavailable.dataset && mblUnavailable.dataset.qaInjected === '1') {
              mblUnavailable.remove();
            } else {
              // If it's original from Liquid, keep it
            }
          }
        }
      }
    },

    setAddingText(inputEl, on) {
      const labelEl = inputEl?.nextElementSibling;
      if (!labelEl) return;
      const addContent = labelEl.querySelector('.mobile-bag-text .add-content');
      if (!addContent) return;

      if (on) {
        if (!addContent.dataset.qaOriginalText) {
          addContent.dataset.qaOriginalText = addContent.textContent;
        }
        addContent.textContent = 'Adding';
      } else {
        if (addContent.dataset.qaOriginalText) {
          addContent.textContent = addContent.dataset.qaOriginalText;
          delete addContent.dataset.qaOriginalText;
        }
      }
    },

    _uiTimer: null,

    updateQtyMapFromCartData(cartData) {
      try {
        const items = cartData && Array.isArray(cartData.items) ? cartData.items : null;
        if (!items) return false;

        const map = new Map();
        items.forEach((it) => {
          if (!it) return;
          const vid = (typeof it.variant_id !== 'undefined' && it.variant_id !== null) ? it.variant_id
                    : (typeof it.variantId !== 'undefined' && it.variantId !== null) ? it.variantId
                    : (typeof it.id !== 'undefined' && it.id !== null) ? it.id
                    : null;
          if (vid === null) return;

          const qRaw = (typeof it.quantity !== 'undefined') ? it.quantity
                     : (typeof it.qty !== 'undefined') ? it.qty
                     : 0;
          const q = parseInt(qRaw, 10) || 0;

          const key = String(vid);
          map.set(key, (map.get(key) || 0) + q);
        });

        this.qtyMap = map;
        this.cartTs = Date.now();
        return true;
      } catch (e) {
        return false;
      }
    },

    scheduleUIRefresh() {
      clearTimeout(this._uiTimer);
      this._uiTimer = setTimeout(() => {
        try { this.refreshOpenPopup(); } catch (e) {}
        try { this.refreshAllCards(); } catch (e) {}
      }, 120);
    },

    refreshAllCards() {
      const cards = document.querySelectorAll('.card-wrapper');
      if (!cards || !cards.length) return;
      cards.forEach((card) => {
        try { this.refreshContainer(card); } catch (e) {}
      });
    },

    refreshOpenPopup() {
      const popup = document.querySelector('.main_quick_add_data_wraper');
      if (!popup || !popup.classList.contains('active')) return;
      if (window.__QA_HOLD_ADDING_UNTIL_CART__) return;
      this.refreshContainer(popup);
    },

    refreshContainer(containerEl) {
      if (!containerEl) return;

      const isPopup = containerEl.classList && containerEl.classList.contains('main_quick_add_data_wraper');
      const inputs = containerEl.querySelectorAll('.size_variants');
      if (!inputs || !inputs.length) return;

      // If we're inside the mobile quick-add popup, try to resolve variants via the original card in the collection (most reliable).
      let sourceCard = null;
      if (isPopup) {
        const matchItem = containerEl.querySelector('.variants_main_wraper')?.getAttribute('data-match') || '';
        const esc = (s) => {
          try { return (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s).replace(/"/g, '\"'); } catch (e) { return String(s); }
        };
        if (matchItem) {
          const sourceWrap = document.querySelector('.card-wrapper .variants_main_wraper[data-match="' + esc(matchItem) + '"]');
          sourceCard = sourceWrap ? sourceWrap.closest('.card-wrapper') : null;
        }
      }

      inputs.forEach((inputEl) => {
        // Skip size inputs that live inside hidden .metafield-products-sizes template divs.
        // These divs are pre-rendered data stores consumed by updateSelectedColor() when
        // a color swatch is clicked.  Mutating them here (with setUnavailable) corrupts
        // the HTML that gets injected into the Quick Add overlay, causing sizes to show
        // as unavailable even when the selected color swatch has real stock.
        if (inputEl.closest('.metafield-products-sizes')) return;

        const label = inputEl.getAttribute('data-label') || '';

        let resolved = null;

        if (sourceCard && label) {
          try {
            const esc = (s) => {
              try { return (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s).replace(/"/g, '\"'); } catch (e) { return String(s); }
            };
            const sourceInput = sourceCard.querySelector('.size_variants[data-label="' + esc(label) + '"]');
            if (sourceInput) resolved = this.resolveOptionForInput(sourceInput);
          } catch (e) {}
        }

        if (!resolved) resolved = this.resolveOptionForInput(inputEl);
        if (!resolved || !resolved.variantId) return;

        const qty = this.qtyMap.get(String(resolved.variantId)) || 0;
        const stock = resolved.stock;

        if (typeof stock === 'number') {
          const unavailable = stock <= qty || stock < 1;
          this.setUnavailable(inputEl, unavailable);
        }
      });
    }
  };

  window.__QA = QA;

  // Track cart updates so we can hold success UI until THIS add is reflected in the cart
  window.__QA_CART_UPDATE_SEQ__ = window.__QA_CART_UPDATE_SEQ__ || 0;
  window.__QA_LAST_CART_UPDATE_AT__ = window.__QA_LAST_CART_UPDATE_AT__ || 0;
  function __qaBumpCartUpdateSeq() {
    try {
      window.__QA_CART_UPDATE_SEQ__ = (window.__QA_CART_UPDATE_SEQ__ || 0) + 1;
      window.__QA_LAST_CART_UPDATE_AT__ = Date.now();
    } catch (e) {}
  }

  // Keep availability in-sync when cart changes (add/remove/qty changes)
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        __qaBumpCartUpdateSeq();
        const cartData = payload && payload.cartData ? payload.cartData : payload;
        const ok = QA.updateQtyMapFromCartData(cartData);
        if (!ok) {
          QA.fetchCart(true).then(() => QA.scheduleUIRefresh());
        } else {
          QA.scheduleUIRefresh();
        }
      });
    }
  } catch (e) {}

  // Also listen to the custom drawer refresh event used in this theme
  document.addEventListener('cart:drawer:updated', function (ev) {
    __qaBumpCartUpdateSeq();
    try {
      const cart = ev && ev.detail && ev.detail.cart ? ev.detail.cart : (ev && ev.detail && ev.detail.items ? ev.detail : null);
      const ok = QA.updateQtyMapFromCartData(cart);
      if (!ok) {
        QA.fetchCart(true).then(() => QA.scheduleUIRefresh());
      } else {
        QA.scheduleUIRefresh();
      }
    } catch (e) {}
  });

  // When the mobile Quick Add popup opens / refreshes its HTML, sync availability immediately
  function bindQAPopupObserver() {
    const popup = document.querySelector('.main_quick_add_data_wraper');
    if (!popup || popup.dataset.qaObserved === '1') return;
    popup.dataset.qaObserved = '1';

    let timer = null;
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!popup.classList.contains('active')) return;
        QA.fetchCart(true).then(() => QA.refreshOpenPopup());
      }, 80);
    };

    const obs = new MutationObserver(() => {
      if (popup.classList.contains('active')) schedule();
    });

    obs.observe(popup, { attributes: true, attributeFilter: ['class'], childList: true });
  }

  // Prefetch cart on load so after F5 / navigation the first hover/open has correct state
  // Default minimum spinner time before tick (ms)
  if (typeof window.__QA_MIN_SPINNER_MS__ !== 'number') window.__QA_MIN_SPINNER_MS__ = 400;

  // Desktop: optional minimum tick hold (ms). Default 0 keeps V7 behavior (tick holds until cart opens).
  if (typeof window.__QA_DSK_TICK_MIN_MS__ !== 'number') window.__QA_DSK_TICK_MIN_MS__ = 0;

  // Mobile popup: spinner before tick and tick hold duration (ms)
  if (typeof window.__QA_MBL_SPINNER_MS__ !== 'number') window.__QA_MBL_SPINNER_MS__ = 1000;
  if (typeof window.__QA_MBL_TICK_MS__ !== 'number') window.__QA_MBL_TICK_MS__ = 1000;


  // function qaPrefetchCart() {
  //   try { QA.fetchCart(true); } catch (e) {}
  // }
   function qaPrefetchCart() {
    try {
      QA.fetchCart(true).then(() => {
        try { QA.refreshAllCards(); } catch (e) {}
      });
    } catch (e) {}
  }

  window.qaPrefetchCart = qaPrefetchCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', qaPrefetchCart);
  } else {
    qaPrefetchCart();
  }
  window.addEventListener('pageshow', function (ev) {
    if (!ev) return;

    var isBfCache = !!ev.persisted;

    // Also detect non-bfcache back/forward navigation (desktop Chrome / disk-cache
    // restores where the browser re-runs the page from cache with persisted=false).
    // collection-to-collection back works via pushState/AJAX and never fires pageshow,
    // so this handler is only relevant for back navigation to non-collection pages
    // (homepage, product pages, etc.) where the full page reloads from disk cache.
    var isBackForward = isBfCache;
    if (!isBackForward) {
      try {
        var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
        if (navEntries && navEntries[0] && navEntries[0].type === 'back_forward') {
          isBackForward = true;
        }
      } catch (e) {}
    }

    if (!isBackForward) return;

    // Refresh QA stock snapshot only for true bfcache restores; disk-cache back/forward
    // re-runs DOMContentLoaded which already calls qaPrefetchCart().
    if (isBfCache) qaPrefetchCart();

    // Always refresh the cart count bubble on any back/forward navigation so that
    // additions made on other pages (e.g. Quick Add on a collection page) are reflected.
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(function (bubble) {
          var span = bubble.querySelector('span[aria-hidden="true"]');
          if (!span) return;
          span.textContent = cart.item_count;
          if (cart.item_count > 0) {
            bubble.classList.remove('cart-count-0');
          } else {
            bubble.classList.add('cart-count-0');
          }
        });

        // audit M16 — silently refresh the drawer's item list after back/forward so it
        // never shows a stale snapshot. Swap-only: does NOT open the drawer and does not
        // change its open/closed state; if it was restored open, it stays open, now fresh.
        try {
          var m16Url = new URL(window.location.pathname, window.location.origin);
          m16Url.searchParams.set('sections', 'cart-drawer');
          m16Url.searchParams.set('cb', Date.now());
          fetch(m16Url.toString(), { cache: 'no-store', credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              var html = data && (data['cart-drawer'] || data['cart_drawer']);
              if (!html) return;
              var doc16 = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc16.getElementById('CartDrawer');
              var live = document.getElementById('CartDrawer');
              if (!fresh || !live) return;
              live.innerHTML = fresh.innerHTML;
              if (cart && cart.item_count > 0) {
                var drawerEl16 = document.querySelector('cart-drawer');
                if (drawerEl16) drawerEl16.classList.remove('is-empty');
              }
              try { document.dispatchEvent(new Event('cart:drawer:updated')); } catch (e) {}
            })
            .catch(function () {});
        } catch (e) {}
      })
      .catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindQAPopupObserver);
  } else {
    bindQAPopupObserver();
  }
})();


// size variant click
document.addEventListener("click", function (e) {
  const Input = e.target.closest(".size_variants");

  if (!Input) return; // Not a size variant click
  // Prevent double-add: popup click is handled separately (it triggers the card click).
  if (Input.closest(".main_quick_add_data_wraper.active")) return;

  const sizeOptionIndex = parseInt(Input.dataset.optionIndex);
  const labelElement = Input.nextElementSibling;
  try {
    window.__QA_LAST_INPUT__ = Input;
    window.__QA_LAST_LABEL__ = labelElement;
  } catch (e) {}

const loader = labelElement ? labelElement.querySelector(".variants_add-loader") : null;
const loader2 = labelElement ? labelElement.querySelector(".variants_add-loader2") : null;

  // Show all .mbl_loader2 loaders inside the labelElement
  if (labelElement) {
  labelElement.querySelectorAll(".mbl_loader2").forEach((mblLoader2) => {
    mblLoader2.classList.remove("hidden");
  });
}

  // Toggle loaders
if (loader && loader2) {
  if (loader.classList.contains("hidden")) {
    loader.classList.remove("hidden");
    loader2.classList.add("hidden");
  } else {
    loader.classList.add("hidden");
    loader2.classList.remove("hidden");
  }
}

  // Remove added_item from all, then add to this one
  document.querySelectorAll(".size_variants").forEach((i) => {
    i.classList.remove("added_item");
  });
  Input.classList.add("added_item");

  const MainWraper = Input.closest(".card-wrapper");
  const sizeLabel = Input.getAttribute("data-label");
  const singleId = Input.getAttribute("data-id");

  if (singleId) {
    addToCartCardItem(singleId);
  } else {
// console.warn("Fallback triggered:", MainWraper, Input); // audit M10 — silenced: the "fallback" IS the primary path by design (size inputs carry no data-id); logged on every quick-add

const colorLabel =
  MainWraper.querySelector(".color_variants:checked")?.getAttribute("data-label") ||
  MainWraper.querySelector(".color_product_main.active_color")?.getAttribute("data-label") ||
  MainWraper.querySelector(".varinats_check_input_color")?.getAttribute("data-label");

if (!colorLabel) {
  console.warn("No color label found inside this card");
  return;
}
    let matchAbelValue = "";
    if (sizeOptionIndex === 1) {
      matchAbelValue = `${sizeLabel}-${colorLabel}`;
    } else if (sizeOptionIndex === 2) {
      matchAbelValue = `${colorLabel}-${sizeLabel}`;
    }

    const variantSelector = MainWraper.querySelector(".variants_seletor_box");

    let matchingOption = null;

    if (variantSelector) {
      const allOptions = variantSelector.querySelectorAll(
        "option[data-handels]"
      );
      allOptions.forEach((option) => {
        const handle = option.getAttribute("data-handels");
        if (
          handle === matchAbelValue ||
          handle.endsWith(`-${colorLabel}`) ||
          (handle.includes(sizeLabel) && handle.includes(colorLabel))
        ) {
          matchingOption = option;
        }
      });
    }

    if (!matchingOption) {
      console.warn("No matching option found for:", matchAbelValue);
      return;
    }

    const selectedId = matchingOption.getAttribute("data-id");
    const productId = parseInt(selectedId.trim(), 10);

    if (!isNaN(productId)) {
      // === Stock respect (cart-aware) ===
      const QA = window.__QA;
      if (QA) {
        // mark wrapper/card as touched so we can refresh it later if needed
        try { (MainWraper || Input.closest('.card-wrapper'))?.setAttribute('data-qa-touched', '1'); } catch (e) {}

        const resolved = QA.resolveOptionForInput(Input);
        // If we can resolve stock, enforce. If not, fall back to old behavior.
        (async function () {
          // Prevent double add while we validate
          const vid = String(productId);
          if (QA.inflight.has(vid)) {
            // stop loaders to avoid stuck states
            try { hideloader(); setTimeout(hideloader2, 200); } catch (e) {}
            return;
          }

          await QA.fetchCart(false);

          let canAdd = true;
          if (resolved && typeof resolved.stock === 'number') {
            const qty = QA.qtyMap.get(String(resolved.variantId)) || 0;
            if (resolved.stock <= qty || resolved.stock < 1) canAdd = false;
          }

          if (!canAdd) {
            // Do not add. Apply existing unavailable UI (line-through / disabled) without new design.
            QA.setUnavailable(Input, true);
            try { hideloader(); setTimeout(hideloader2, 200); } catch (e) {}
            return;
          }

          // show "Adding" next to existing spinner in mobile
          QA.setAddingText(Input, true);

          QA.inflight.add(vid);
          // Safety unlock even if something fails
          setTimeout(() => { try { QA.inflight.delete(vid); } catch (e) {} }, 2000);

          addToCartCardItem(productId);

          // Refresh availability after add so last unit becomes unavailable
          const __qaDelay = (window.__QA_HOLD_ADDING_UNTIL_CART__ ? 1800 : 600);
          setTimeout(() => {
            QA.fetchCart(true).then(() => {
              // refresh this card and open popup if any
              try { QA.refreshContainer(MainWraper || Input.closest('.card-wrapper')); } catch (e) {}
              try { QA.refreshOpenPopup(); } catch (e) {}
            });
          }, __qaDelay);
        })();
      } else {
        addToCartCardItem(productId);
      }
    } else {
      console.error("Invalid product ID:", selectedId);
    }
  }
});

function hideloader() {
  var hold = !!window.__QA_HOLD_ADDING_UNTIL_CART__;
  var loader = document.querySelectorAll(".variants_add-loader");
  loader.forEach((loader) => {
    loader.classList.add("hidden");
  });
  var addedItem = (window.__QA_LAST_INPUT__ && document.contains(window.__QA_LAST_INPUT__)) ? window.__QA_LAST_INPUT__ : document.querySelector(".added_item");
var loaderParent = addedItem
  ? addedItem.closest(".variant_wraper_label")
  : null;
    if (loaderParent) {
    var loader2 = loaderParent.querySelector(".variants_add-loader2");
if (loader2) loader2.classList.remove("hidden");

    var addedItemEl = addedItem || document.querySelector(".added_item");
if (addedItemEl) {
  var addedItemInputSize = addedItemEl.dataset.label;

  var activeMobileQuickAddPopup = document.querySelector(
    ".main_quick_add_data_wraper.large-up-hide.active"
  );
  if (activeMobileQuickAddPopup) {
    var selectedInput = activeMobileQuickAddPopup.querySelector(
      '.varinats_check_input[data-label="' + addedItemInputSize + '"]'
    );

    var MobileQuickAddSelectedSize = selectedInput
      ? selectedInput.nextElementSibling
      : null;

    var mblLoader2s = MobileQuickAddSelectedSize
      ? MobileQuickAddSelectedSize.querySelector(".mbl_loader2")
      : null;

    if (mblLoader2s) mblLoader2s.classList.remove("hidden");
  }
}
  }

  if (hold) {
    return;
  }

  var mblLoader = document.querySelectorAll(".mbl_loader");
  mblLoader.forEach((loader) => {
    loader.classList.add("hidden");
  });

  var bagIcon = document.querySelectorAll(".icon-add-to-bag");
  setTimeout(function () {
    bagIcon.forEach((loader) => {
      loader.classList.remove("hidden");
    });
  }, 1000);
  var bagContent = document.querySelectorAll(".add-content");
  bagContent.forEach((content) => {
    content.textContent = "Add to bag";
  });
}

function hideloader2() {
  // Restore mobile "Add to bag" text if it was temporarily changed to "Adding"
  try {
    const QA = window.__QA;
    if (QA) {
      document.querySelectorAll('.size_variants').forEach((inp) => QA.setAddingText(inp, false));
    }
  } catch (e) {}

  var loader2 = document.querySelectorAll(".variants_add-loader2");
  loader2.forEach((loader) => {
    loader.classList.add("hidden");
  });

  var mblLoader2 = document.querySelectorAll(".mbl_loader2");
  mblLoader2.forEach((loader) => {
    loader.classList.add("hidden");
  });
}
function qaIsCartDrawerOpen() {
  var drawer = document.querySelector("cart-drawer");
  if (!drawer) return false;
  if (drawer.classList.contains("active") || drawer.classList.contains("animate")) return true;
  if (document.body.classList.contains("overflow-hidden")) return true;
  return false;
}

function qaIsQuickAddPopupOpen() {
  var wrap = document.querySelector(".main_quick_add_data_wraper");
  return !!(wrap && wrap.classList.contains("active"));
}

function qaFinalizeAfterCartAndPopup() {
  var start = Date.now();
  window.__QA_UI_FINALIZE_SEQ__ = (window.__QA_UI_FINALIZE_SEQ__ || 0) + 1;
  var token = window.__QA_UI_FINALIZE_SEQ__;
  var expectedSeq = window.__QA_EXPECT_CART_UPDATE_SEQ__ || 0;

  (function poll() {
    if (token !== window.__QA_UI_FINALIZE_SEQ__) return;

    var cartOpen = qaIsCartDrawerOpen();
    var popupOpen = qaIsQuickAddPopupOpen();

    var gotUpdate = true;
    if (expectedSeq) {
      gotUpdate = (window.__QA_CART_UPDATE_SEQ__ || 0) >= expectedSeq;
    }

    if (gotUpdate && cartOpen && !popupOpen && (Date.now() - start > 250)) {
      window.__QA_HOLD_ADDING_UNTIL_CART__ = false;
      try { hideloader2(); } catch (e) {}

      try {
        document.querySelectorAll(".mbl_loader").forEach(function (l) { l.classList.add("hidden"); });
        document.querySelectorAll(".icon-add-to-bag").forEach(function (i) { i.classList.remove("hidden"); });
        document.querySelectorAll(".add-content").forEach(function (c) {
          if ((c.textContent || "").trim() === "Adding") c.textContent = "Add to bag";
        });
      } catch (e) {}
      return;
    }

    if (Date.now() - start > 6500) {
      window.__QA_HOLD_ADDING_UNTIL_CART__ = false;
      try { hideloader2(); } catch (e) {}
      try {
        document.querySelectorAll(".mbl_loader").forEach(function (l) { l.classList.add("hidden"); });
        document.querySelectorAll(".icon-add-to-bag").forEach(function (i) { i.classList.remove("hidden"); });
        document.querySelectorAll(".add-content").forEach(function (c) {
          if ((c.textContent || "").trim() === "Adding") c.textContent = "Add to bag";
        });
      } catch (e) {}
      return;
    }

    setTimeout(poll, 60);
  })();
}


// Desktop: keep the selected size (checkmark state) until the cart drawer actually starts opening.
// This prevents the "tick flashes for 1s then disappears" behavior on 2nd/3rd adds.
function qaFinalizeDesktopTickAfterCartOpen(sizeInputs) {
  var arr = [];
  try { arr = Array.prototype.slice.call(sizeInputs || []); } catch (e) { arr = []; }

  window.__QA_DESKTOP_TICK_SEQ__ = (window.__QA_DESKTOP_TICK_SEQ__ || 0) + 1;
  var seq = window.__QA_DESKTOP_TICK_SEQ__;
  var start = Date.now();
  var expectedSeq = window.__QA_EXPECT_CART_UPDATE_SEQ__ || 0;

  (function poll() {
    if (seq !== window.__QA_DESKTOP_TICK_SEQ__) return;

    var cartOpen = qaIsCartDrawerOpen();

    var gotUpdate = true;
    if (expectedSeq) {
      gotUpdate = (window.__QA_CART_UPDATE_SEQ__ || 0) >= expectedSeq;
    }

    var minTick = (typeof window.__QA_DSK_TICK_MIN_MS__ === "number") ? window.__QA_DSK_TICK_MIN_MS__ : 0;
    var tickOk = (Date.now() - start) >= minTick;

    if (cartOpen && gotUpdate && tickOk) {
      setTimeout(function () {
        if (seq !== window.__QA_DESKTOP_TICK_SEQ__) return;
        try { arr.forEach(function (el) { el && el.classList && el.classList.remove("added_item"); }); } catch (e) {}
      }, 250);
      return;
    }

    if (Date.now() - start > 7000) {
      try { arr.forEach(function (el) { el && el.classList && el.classList.remove("added_item"); }); } catch (e) {}
      return;
    }

    setTimeout(poll, 70);
  })();
}


function addToCartCardItem(productId) {
  var SizeInputs = document.querySelectorAll(".size_variants");

  const CardAjax = new XMLHttpRequest();
  CardAjax.open("POST", "/cart/add.js", true);
  CardAjax.setRequestHeader("Content-Type", "application/json");
  const dataAdd = JSON.stringify({ quantity: 1, id: productId });

// QA: remember this add so we can keep UI consistent across repeated adds
try {
  window.__QA_LAST_ADD_CLICK_AT__ = Date.now();
  window.__QA_LAST_ADD_CLICK_ID__ = String(productId);
  window.__QA_EXPECT_CART_UPDATE_SEQ__ = (window.__QA_CART_UPDATE_SEQ__ || 0) + 1;
} catch (e) {}

CardAjax.onreadystatechange = function () {
  if (CardAjax.readyState !== 4) return;

  if (CardAjax.status === 200) {
    window.__QA_HOLD_ADDING_UNTIL_CART__ = true;

    // Always start finalize polling (it will release "Adding" only after cart is open and popup is closed)
    qaFinalizeAfterCartAndPopup();
    qaFinalizeDesktopTickAfterCartOpen(SizeInputs);

    // Detect if this add originated from the MOBILE quick-add popup
    var __qaPopupCtx = null;
    try { __qaPopupCtx = window.__QA_LAST_MOBILE_POPUP_ADD__ || null; } catch (e) { __qaPopupCtx = null; }
    var __qaMobilePopupOpen = !!document.querySelector(".main_quick_add_data_wraper.large-up-hide.active");
    var __qaIsMobilePopupAdd = !!(__qaPopupCtx && __qaMobilePopupOpen && (Date.now() - (__qaPopupCtx.at || 0) < 8000));

    if (__qaIsMobilePopupAdd) {
      var spinnerMs = (typeof __qaPopupCtx.spinnerMs === "number") ? __qaPopupCtx.spinnerMs : ((typeof window.__QA_MBL_SPINNER_MS__ === "number") ? window.__QA_MBL_SPINNER_MS__ : 1000);
      var tickMs = (typeof __qaPopupCtx.tickMs === "number") ? __qaPopupCtx.tickMs : ((typeof window.__QA_MBL_TICK_MS__ === "number") ? window.__QA_MBL_TICK_MS__ : 1000);

      // 1) Keep spinner visible for spinnerMs TOTAL (counted from the click), then switch to tick (via existing hideloader)
      var __qaElapsed = 0;
      try { __qaElapsed = Date.now() - (__qaPopupCtx.at || Date.now()); } catch (e) { __qaElapsed = 0; }
      var __qaWaitSpinner = Math.max(0, Math.max(0, spinnerMs) - Math.max(0, __qaElapsed));
      setTimeout(function () {
        try { hideloader(); } catch (e) {}

        // Hide the "Adding" spinner (mbl_loader) once the tick shows, so there's only ONE spinner total
        try {
          var activePopup = document.querySelector(".main_quick_add_data_wraper.large-up-hide.active");
          if (activePopup && __qaPopupCtx.size) {
            var sel = activePopup.querySelector('.varinats_check_input[data-label="' + __qaPopupCtx.size + '"]');
            if (sel && sel.nextElementSibling) {
              var mb = sel.nextElementSibling.querySelector(".mobile-bag-text");
              if (mb) {
                var mblLoader = mb.querySelector(".mbl_loader");
                if (mblLoader) mblLoader.classList.add("hidden");
                // ensure tick is visible
                var tickWrap = mb.querySelector(".mbl_loader2");
                if (tickWrap) tickWrap.classList.remove("hidden");
              }
            }
          }
        } catch (e) {}
      }, __qaWaitSpinner);

      // 2) After spinner + tick duration, close popup and open cart drawer
      var totalMs = __qaWaitSpinner + Math.max(0, tickMs);

      setTimeout(function () {
        // Close quick add popup first (so finalize can release after drawer opens)
        try {
          var overlay = document.querySelector(".quick_add_overlay");
          if (overlay) overlay.classList.add("hidden");

          var wrap = document.querySelector(".main_quick_add_data_wraper");
          if (wrap) wrap.classList.remove("active");

          document.body.classList.remove("quick_add_open");
        } catch (e) {}

        // Now open/update cart drawer
        reloadCartDrawerFromServer();

        // Clear ctx so next add isn't treated as popup add by mistake
        try { window.__QA_LAST_MOBILE_POPUP_ADD__ = null; } catch (e) {}
      }, totalMs);

    } else {
      // Non-popup add (desktop / card): open cart immediately and use the existing short spinner->tick timing
      reloadCartDrawerFromServer();

      var minSpinnerMs = (typeof window.__QA_MIN_SPINNER_MS__ === "number") ? window.__QA_MIN_SPINNER_MS__ : 400;
      var clickedAt = window.__QA_LAST_ADD_CLICK_AT__ || 0;
      var wait = Math.max(0, minSpinnerMs - (Date.now() - clickedAt));

      setTimeout(function () { try { hideloader(); } catch (e) {} }, wait);

      setTimeout(function () {
        var overlay = document.querySelector(".quick_add_overlay");
        if (overlay) overlay.classList.add("hidden");

        const wrap = document.querySelector(".main_quick_add_data_wraper");
        if (wrap) wrap.classList.remove("active");

        document.body.classList.remove("quick_add_open");
      }, 1500);
    }
  } else {
    console.error("Add to cart failed:", CardAjax.status, CardAjax.responseText);

    // If Shopify rejects due to stock (422), mark this size as unavailable (existing UI class)
    try {
      if (CardAjax.status === 422 && window.__QA) {
        const added = document.querySelector('.added_item');
        if (added) window.__QA.setUnavailable(added, true);
        // refresh popup if open so it stays consistent
        window.__QA.fetchCart(true).then(() => window.__QA.refreshOpenPopup());
      }
    } catch (e) {}

    hideloader();
    setTimeout(hideloader2, 300);

    SizeInputs.forEach((i) => i.classList.remove("added_item"));

  }

  // QA: unlock inflight + keep availability synced
  try {
    if (window.__QA) {
      window.__QA.inflight && window.__QA.inflight.delete(String(productId));
      window.__QA.fetchCart(true).then(() => window.__QA.scheduleUIRefresh && window.__QA.scheduleUIRefresh());
    }
  } catch (e) {}
};

  CardAjax.send(dataAdd);
}

// ========================Aqsa======================
function mobilePopup() {
  var popupVariant = document.querySelectorAll(
    ".main_quick_add_data_wraper .size_variants"
  );

  popupVariant.forEach((popupSize) => {
    popupSize.addEventListener("click", function () {
      var matchSize = this.getAttribute("data-label");
      var variantsWrap = this.closest(".variants_main_wraper");
      if (!variantsWrap) return;
      var matchItem = variantsWrap.getAttribute("data-match");
      var correctItems = document.querySelectorAll(".card-wrapper");

      var labelElement = popupSize.nextElementSibling;
if (!labelElement) return;

var mblContent = labelElement.querySelector(".mobile-bag-text");
if (!mblContent) return;
      var addBag = mblContent.querySelector(".add-content");
      var mblBagIcon = mblContent.querySelector(".icon-add-to-bag");
      var mblLoader = mblContent.querySelector(".mbl_loader");
      var mblTickWrap = mblContent.querySelector(".mbl_loader2");

      // Mobile popup feedback sequence:
      // 1) show ONE spinner (at tick area) for __QA_MBL_SPINNER_MS__
      // 2) then show the tick for __QA_MBL_TICK_MS__
      // 3) only then open the cart drawer + close popup
      var __qaSpinnerMs = (typeof window.__QA_MBL_SPINNER_MS__ === "number") ? window.__QA_MBL_SPINNER_MS__ : 1000;
      var __qaTickMs = (typeof window.__QA_MBL_TICK_MS__ === "number") ? window.__QA_MBL_TICK_MS__ : 1000;
      try {
        window.__QA_LAST_MOBILE_POPUP_ADD__ = {
          at: Date.now(),
          size: matchSize,
          match: matchItem,
          spinnerMs: __qaSpinnerMs,
          tickMs: __qaTickMs
        };
      } catch (e) {}

      if (addBag) addBag.textContent = "Adding";
      if (mblBagIcon) mblBagIcon.classList.add("hidden");

      // Show spinner now, and ensure tick is hidden until we explicitly switch to it
      if (mblLoader) mblLoader.classList.remove("hidden");
      if (mblTickWrap) mblTickWrap.classList.add("hidden");
      correctItems.forEach((card) => {
        var matchedItem = card.querySelector(
          '.variants_main_wraper[data-match="' + matchItem + '"]'
        );

        if (matchedItem) {
          var innerInputs = matchedItem.querySelectorAll(".size_variants");

          innerInputs.forEach((input) => {
            if (input.getAttribute("data-label") === matchSize) {
              input.click();

            }
          });
        }
      });
    });
  });
}

function checkVariants() {
  var checkColor = document.querySelectorAll(
    ".main_variants_color_wraper_card .color_variants"
  );
  checkColor.forEach((colorvariant) => {
    if (colorvariant.dataset.variantsBound === "1") return;
    colorvariant.dataset.variantsBound = "1";
    colorvariant.addEventListener("click", function () {
      var checkcolor = this.getAttribute("data-label");
      var sizevariant = this.closest(".card-wrapper").querySelectorAll(
        ".variant_wraper_label"
      );
      sizevariant.forEach((sizevariable) => {
        var checksize = sizevariable
          .querySelector("input")
          .getAttribute("data-label");
        var matchvalue = checkcolor + "-" + checksize;

        var option = this.closest(".card-wrapper").querySelector(
          ".variants_seletor_box .varinats_options[data-handels='" +
            matchvalue +
            "']"
        );

        if (!option) return;
var newoption = option.getAttribute("data-stock");
        if (Number(newoption) === 0) {
          option.classList.add("unavailable");
        }
        var bagTextElement = sizevariable
          .closest(".variant_wraper_label")
          .querySelector(".varinat_label_value .mobile-bag-text");
          if (!bagTextElement) return;
        if (option && parseInt(newoption) > 0) {
          var newtext =
            'Add to bag  <svg class="icon-add-to-bag" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path></svg>';
          bagTextElement.innerHTML = newtext;
        } else {
          var newtext2 = "Out of Stock";
          bagTextElement.innerHTML = newtext2;
          bagTextElement.classList.add("out-of-stock");
        }
      });
    });
  });
}

checkVariants();

var addToCartBtn = document.getElementById("add-to-cart-form-btn");
var addToCartSticky = document.querySelector(".sticky-btn-mobile");
var productFormSubmitBtn = document.querySelector(".default_add-to_cart_btn");
if (addToCartBtn) {
  var commonAncestor = addToCartBtn.closest(".product__info-wrapper");
  // Guard: if the button exists but isn't inside .product__info-wrapper (e.g. GemPages
  // template restructures the DOM), closest() returns null — bail out to avoid crash.
  if (!commonAncestor) { addToCartBtn = null; }
}
if (addToCartBtn && commonAncestor) {
  var sizeBorderCol = commonAncestor.querySelector(".size-border-col");
  // Guard: .size-border-col is required for the rest of this block.
  if (!sizeBorderCol) { addToCartBtn = null; }
}
if (addToCartBtn && commonAncestor && sizeBorderCol) {
  var radios = sizeBorderCol.querySelectorAll('input[type="radio"]');
  let selectedRadio = null;

  var message = commonAncestor.querySelector(".mobil-cart-mesage");

  radios?.forEach((sizeRadio) => {
    if (sizeRadio.checked) {
      selectedRadio = sizeRadio;
    }
  });

  if (selectedRadio) {
    addToCartBtn.classList.add("hidden");
    productFormSubmitBtn.classList.remove("hidden");
  }

  addToCartBtn.addEventListener("click", function () {
    if (window.allVariantsSoldOut) {
      return;
    }

    if (sizeBorderCol) {
      radios?.forEach((sizeRadio) => {
        if (sizeRadio.checked) {
          selectedRadio = sizeRadio;
        }
      });
      if (!selectedRadio) {
        sizeBorderCol.classList.add("borderd-cart-div");
      }
    }

    if (message) {
      if (!selectedRadio) {
        message.classList.remove("hidden");
      }
    }
  });

  radios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      if (this.checked) {
        sizeBorderCol.classList.remove("borderd-cart-div");
        if (message) {
          message.classList.add("hidden");
        }

        addToCartBtn.classList.add("hidden");
        productFormSubmitBtn.classList.remove("hidden");
      } else {
        sizeBorderCol.classList.add("borderd-cart-div");
        if (message) {
          message.classList.remove("hidden");
        }

        addToCartBtn.classList.add("hidden");
        productFormSubmitBtn.classList.remove("hidden");
      }
    });
  });
}
// =============================================================
// Gift card: enforce amount selection before Add-to-bag works.
// Discriminator: on size pages the fake "Select a Size" button
// (#add-to-cart-form-btn) exists; on the gift card it does not.
// =============================================================
(function () {
  var pageWrapper = document.querySelector('.product__info-wrapper');
  if (!pageWrapper) return;
  if (pageWrapper.querySelector('#add-to-cart-form-btn')) return;

  var optionsBox = pageWrapper.querySelector('.size-border-col');
  if (!optionsBox) return;

  var realBtn = pageWrapper.querySelector('.default_add-to_cart_btn');
  if (!realBtn) return;

  var gcRadios = optionsBox.querySelectorAll('input[type="radio"]');
  if (!gcRadios.length) return;

  var gcMessage = pageWrapper.querySelector('.mobil-cart-mesage');

  function gcAnyRadioChecked() {
    for (var i = 0; i < gcRadios.length; i++) {
      if (gcRadios[i].checked) return true;
    }
    return false;
  }

  function gcShowError() {
    optionsBox.classList.add('borderd-cart-div');
    if (gcMessage) gcMessage.classList.remove('hidden');
  }

  function gcClearError() {
    optionsBox.classList.remove('borderd-cart-div');
    if (gcMessage) gcMessage.classList.add('hidden');
  }

  realBtn.addEventListener('click', function (e) {
    if (!gcAnyRadioChecked()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      gcShowError();
    }
  }, true);

  var gcProductForm = realBtn.closest('form');
  if (gcProductForm) {
    gcProductForm.addEventListener('submit', function (e) {
      if (!gcAnyRadioChecked()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        gcShowError();
      }
    }, true);
  }

  gcRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.checked) gcClearError();
    });
  });
})();
function markUnavailableSizesInCards() {
var productCards = document.querySelectorAll(".card-wrapper");

  productCards.forEach(function (productCard) {
    var varinatsCheckInputs = productCard.querySelectorAll(".size_variants");

    varinatsCheckInputs.forEach(function (input) {
      var variantWrapperLabel = input.closest(".variant_wraper_label");
      if (!variantWrapperLabel) return;

      var dataStock = input.getAttribute("data-stock");
      variantWrapperLabel.classList.toggle("unavailable", dataStock === "0");
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  var stickyWrapper = document.getElementById('sticky-buy');
  if (!stickyWrapper) return;

  var fakeMainBtn = document.getElementById('add-to-cart-form-btn');

  var realMainBtn = document.querySelector('.default_add-to_cart_btn');

  var stickyAtc   = document.getElementById('sticky-atc');
  var stickyLabel = document.querySelector('[data-sticky-atc]');

  if (!stickyAtc || !stickyLabel || (!fakeMainBtn && !realMainBtn)) return;

  var addLabel     = 'Add to bag';
  var selectLabel  = 'Select a Size';
  var soldOutLabel = 'Sold out';


  function getSizeWrap() {
    return document.querySelector('.size-border-col');
  }

  function getActiveMainButton() {
    if (realMainBtn && !realMainBtn.classList.contains('hidden')) {
      return realMainBtn;
    }
    return fakeMainBtn || realMainBtn;
  }

  function getMainLabelText() {
    var btn = getActiveMainButton();
    if (!btn) return '';

    var labelEl =
      btn.querySelector('[data-add-to-cart-text]') ||
      btn.querySelector('span') ||
      btn;

    var txt = (labelEl.innerText || labelEl.textContent || '').trim().toLowerCase();
    return txt;
  }

  function getMainMode() {
if (window.allVariantsSoldOut === true) {
  return 'sold';
}

    var text = getMainLabelText();

    if (text.indexOf('sold out') !== -1) {
      return 'sold';
    }

    if (text.indexOf('select a size') !== -1) {
      return 'select';
    }

    if (text.indexOf('add to cart') !== -1 || text.indexOf('add to bag') !== -1) {
      return 'add';
    }

    return 'add';
  }

  function scrollToIdealTarget() {
    var sizeWrap = getSizeWrap();
    var target = sizeWrap || getActiveMainButton();
    if (!target) return;

    var rect = target.getBoundingClientRect();
    var top  = rect.top + window.pageYOffset
             - (window.innerHeight / 2)
             + (target.offsetHeight / 2);

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }

  function updateStickyLabel() {
    var mode = getMainMode();

    if (mode === 'select') {
      stickyLabel.textContent = selectLabel;
    } else if (mode === 'sold') {
      stickyLabel.textContent = soldOutLabel;
    } else {
      stickyLabel.textContent = addLabel;
    }
  }

  updateStickyLabel();

  var observerTargets = [];
  if (fakeMainBtn) observerTargets.push(fakeMainBtn);
  if (realMainBtn) observerTargets.push(realMainBtn);

  if (observerTargets.length) {
    var observer = new MutationObserver(function () {
      updateStickyLabel();
    });

    observerTargets.forEach(function (el) {
      observer.observe(el, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  stickyAtc.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var mode = getMainMode();

    if (mode === 'sold') {
      scrollToIdealTarget();
      return;
    }

    if (mode === 'select') {
      scrollToIdealTarget();

      var sizeWrap = getSizeWrap();
      if (sizeWrap) {
        sizeWrap.classList.add('borderd-cart-div');
      }

      var msg = document.querySelector('.mobil-cart-mesage');
      if (msg) {
        msg.classList.remove('hidden');
      }
      return;
    }

    var activeBtn = getActiveMainButton();
    if (activeBtn) {
      activeBtn.click();
    }

    scrollToIdealTarget();
  });
});

const header = document.querySelector("header");
let headerScrollBound = false;

function handleHeaderScroll() {
  if (!header) return;
  if (window.scrollY > 0) {
    header.classList.remove("transparent_header");
  } else {
    header.classList.add("transparent_header");
  }
}

function bindHeaderScroll() {
  if (!header) return;

  const shouldBind = window.innerWidth > 786;

  if (shouldBind && !headerScrollBound) {
    window.addEventListener("scroll", handleHeaderScroll);
    headerScrollBound = true;
  }

  if (!shouldBind && headerScrollBound) {
    window.removeEventListener("scroll", handleHeaderScroll);
    headerScrollBound = false;
  }

  handleHeaderScroll();
}

if (header) {
  header.classList.add("transparent_header");
  document.addEventListener("DOMContentLoaded", bindHeaderScroll);
  window.addEventListener("resize", bindHeaderScroll);
}

document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector(".footer_nav_wrap");

  if (!footer) return;

  footer.addEventListener("click", function (event) {
    const clickedMenu = event.target.closest(
      ".footer-block__heading.inline-richtext"
    );

    if (clickedMenu) {
      const footerDetail = clickedMenu.nextElementSibling;

      // Close all other menus
      footer
        .querySelectorAll(".footer-block__heading.inline-richtext")
        .forEach((menu) => {
          const otherDetail = menu.nextElementSibling;
          if (menu !== clickedMenu) {
            otherDetail.style.display = "none";
            menu.classList.remove("active");
          }
        });

      // Toggle the clicked menu
      if (
        footerDetail.style.display === "none" ||
        footerDetail.style.display === ""
      ) {
        footerDetail.style.display = "block";
        clickedMenu.classList.add("active");
      } else {
        footerDetail.style.display = "none";
        clickedMenu.classList.remove("active");
      }
    }
  });
});

// Grids Function Collection Page
var gridWrapper = document.querySelector(".items-grid-wrapper");

if (gridWrapper) {
  var allGrids = gridWrapper.querySelectorAll(".product_grids");
  var productsWrapper = document.querySelector("#product-grid");

  function applyGrid(gridValue) {
  if (!productsWrapper) return;

  if (gridValue === "3") {
    productsWrapper.classList.add("grid--3-col-desktop");
    productsWrapper.classList.remove("grid--4-col-desktop");
    productsWrapper.classList.remove("grid-force-4");
  } else {
    productsWrapper.classList.add("grid--4-col-desktop");
    productsWrapper.classList.remove("grid--3-col-desktop");
    productsWrapper.classList.add("grid-force-4");
  }
}

  function setDefaultGridByViewport() {
    var defaultGrid =
      window.innerWidth >= 990 && window.innerWidth <= 1439 ? "3" : "4";

    allGrids.forEach(function (grid) {
      var value = grid.getAttribute("grid");
      if (value === defaultGrid) {
        grid.classList.add("active_grid");
      } else {
        grid.classList.remove("active_grid");
      }
    });

    applyGrid(defaultGrid);
  }

  // initial state on load
  setDefaultGridByViewport();

  // update on resize
  window.addEventListener("resize", setDefaultGridByViewport);

  // manual switcher click
  allGrids.forEach(function (singleGrid) {
    singleGrid.addEventListener("click", function () {
      var gridData = singleGrid.getAttribute("grid");

      allGrids.forEach(function (grid) {
        grid.classList.toggle("active_grid", grid === singleGrid);
      });

      applyGrid(gridData);
    });
  });
}

// Filter CLick Collection Page

// Filter CLick Collection Page

var hide_filter = document.querySelector(".hide_filter");
var show_filter = document.querySelector(".show_filter");
var desktopFilter = document.querySelector(".desktop_filter");

if (desktopFilter && show_filter && hide_filter && gridWrapper) {
  desktopFilter.addEventListener("click", function () {
    show_filter.classList.toggle("hidden");
    hide_filter.classList.toggle("hidden");
    gridWrapper.classList.toggle("hidden");

    var mainCollectionWrapperParent = document.querySelector(".collection_main_container");
    if (mainCollectionWrapperParent) {
      mainCollectionWrapperParent.classList.toggle("hide_filters");
    }
  });
}

document.addEventListener("click", function (event) {
  const colorSwatch = event.target.closest(".color_product_main");
  const gridItem = event.target.closest(".grid__item");

  if (colorSwatch && gridItem) {
    updateSelectedColor(colorSwatch);
    if (window.innerWidth >= 990) imgHover(); // audit H2 — hover rebind is desktop-only
  }
});

/* Preload swatch images on hover/focus/touchstart so the click → image
   swap is instant. Without this, the click fires mainImage.src = newUrl
   and the user waits for the browser to download + decode the bitmap.

   The preload now covers two sources:
   1. p-img attribute  — the main featured image shown in the card thumbnail.
   2. .selected-color-images slide images — the full set of swiper slides stored
      in the hidden template div. These have loading="lazy" and live in a
      display:none container, so the browser never fetches them until the DOM
      swap happens on click. That live fetch is the cause of the 0.5–1s delay
      visible on cards lower in the page where nothing is warm in the CDN cache.
      Preloading them on hover intent eliminates the delay for desktop users.
      For touch, touchstart fires just before click and gives at least a small
      head start over a fully cold fetch. */
(function () {
  var preloaded = new Set();
  function preloadSwatchImage(swatch) {
    if (!swatch) return;

    // 1. Main p-img thumbnail
    var url = swatch.getAttribute("p-img");
    if (url && !preloaded.has(url)) {
      preloaded.add(url);
      var thumb = new Image();
      thumb.decoding = "async";
      thumb.src = url;
    }

    // 2. All slide images inside .selected-color-images (up to 4 per swatch).
    //    Pass srcset + sizes so the browser selects and caches the correct
    //    responsive size, not just the 640px src fallback.
    var slideImgs = swatch.querySelectorAll(
      ".selected-color-images .selcted_slide_imgs-wrapper img"
    );
    slideImgs.forEach(function (imgEl) {
      var src = imgEl.getAttribute("src");
      if (!src || preloaded.has(src)) return;
      preloaded.add(src);
      var pre = new Image();
      pre.decoding = "async";
      var srcset = imgEl.getAttribute("srcset");
      var sizes  = imgEl.getAttribute("sizes");
      if (srcset) pre.srcset = srcset;
      if (sizes)  pre.sizes  = sizes;
      pre.src = src; // must be set after srcset/sizes
    });
  }
  function onIntent(event) {
    var swatch = event.target && event.target.closest && event.target.closest(".color_product_main");
    if (!swatch) return;
    preloadSwatchImage(swatch);

    // On touchstart (mobile intent signal), also prefetch the Quick Add data for
    // this swatch's product so it is cache-warm by the time the tap completes.
    // touchstart fires ~50–300ms before click, giving the fetch a head start.
    // The result is stored in window._qaFetchCache (handle → Promise<string>)
    // so updateSelectedColor() can reuse the in-flight promise instead of
    // starting a duplicate fetch when the click fires.
    if (event.type === 'touchstart' && window.innerWidth < 990) {
      var pLink = swatch.getAttribute('p-link') || '';
      var handle = pLink.replace(/^.*\/products\//, '').split('?')[0].replace(/^\/+/, '');
      if (handle) {
        window._qaFetchCache = window._qaFetchCache || new Map();
        if (!window._qaFetchCache.has(handle)) {
          var url = '/products/' + handle + '?view=quickadd';
          var p = fetch(url, { cache: 'force-cache', credentials: 'same-origin', priority: 'high' })
            .then(function (r) { return r.text(); })
            .catch(function () {
              if (window._qaFetchCache) window._qaFetchCache.delete(handle);
              return '';
            });
          window._qaFetchCache.set(handle, p);
        }
      }
    }
  }
  document.addEventListener("mouseover", onIntent, { passive: true });
  document.addEventListener("focusin", onIntent, { passive: true });
  document.addEventListener("touchstart", onIntent, { capture: true, passive: true });
})();

/* Pre-warm the browser cache for non-primary swatch Quick Add data.
   Primary swatches open instantly because their variant HTML is server-rendered
   on the page. Non-primary swatches need a ?view=quickadd fetch on first tap —
   on mobile this can take 1-3s on a cold cache. By fetching all unique swatch
   quickadd URLs in the background (2s after page load, during idle time), the
   cache is warm before the user interacts, so subsequent taps resolve immediately.
   Uses force-cache: if the page was refreshed the browser cache is already warm
   and no network request is made; only truly cold URLs hit the network. */
(function () {
  function prefetchSwatchQuickAddData() {
    var seen = new Set();
    var swatches = document.querySelectorAll('.color_product_main[p-link]');
    swatches.forEach(function (swatch) {
      var pLink = swatch.getAttribute('p-link') || '';
      var handle = pLink.replace(/^.*\/products\//, '').split('?')[0].replace(/^\/+/, '');
      if (!handle || seen.has(handle)) return;
      seen.add(handle);

      // Skip the primary card's own handle — its data is already on the page, no fetch needed.
      var card = swatch.closest('.grid__item');
      var matchEl = card && card.querySelector('.variants_main_wraper[data-match]');
      if (matchEl) {
        var existingMatch = matchEl.getAttribute('data-match') || '';
        if (existingMatch.endsWith('-' + handle) || existingMatch.includes(handle)) return;
      }

      var url = '/products/' + handle + '?view=quickadd';
      try {
        fetch(url, { method: 'GET', cache: 'force-cache', credentials: 'same-origin' }).catch(function () {});
      } catch (e) {}
    });
  }

  // Run after page is fully loaded — avoids competing with critical resources.
  // On search pages the browser stays busy after load (predictive search scripts, result
  // rendering), so requestIdleCallback can fire close to its 4 000 ms timeout, leaving
  // non-primary swatch quickadd URLs cold when the user taps. We detect the search page
  // and use a shorter fixed delay (800 ms) so the cache is warm before first interaction.
  // Collection pages keep the original idle-callback path (fires quickly on simpler pages).
  window.addEventListener('load', function () {
    var isSearchPage = !!document.querySelector('.template-search__results');
    if (isSearchPage) {
      // Fixed 800 ms — load event guarantees critical assets are done; 800 ms is a safe buffer.
      setTimeout(prefetchSwatchQuickAddData, 800);
    } else if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(prefetchSwatchQuickAddData, { timeout: 4000 });
    } else {
      setTimeout(prefetchSwatchQuickAddData, 2500);
    }
  });
})();

function updateSelectedColor(singleColor) {
  if (!singleColor) return;

  const productCard = singleColor.closest(".grid__item");
  if (!productCard) return;

  const specificColor = singleColor.dataset.specificColor;
  const colorLabelContainer = productCard.querySelector(".card-specific-color");
  if (colorLabelContainer) colorLabelContainer.innerHTML = specificColor;

  const productHandle = singleColor.getAttribute("p-link")?.replace("/products/", "");
  if (!productHandle) return;

  const productUrl = `/products/${productHandle}?view=quickadd`;

  // Handle quick add data for mobile
  if (window.innerWidth < 990) {
    // Mark this card as pending so Quick_Add.js can detect an in-flight swatch refresh.
    // Store the promise directly so waitForQuickAddReady() can await it instead of polling.
    productCard.dataset.quickaddPending = "1";

    // Reuse an in-progress touchstart prefetch if available (window._qaFetchCache).
    // onIntent fires on touchstart (~50-300ms before click) and pre-starts the fetch,
    // storing a Promise<string> keyed by handle. Consuming it here avoids a duplicate
    // network request and gives maximum time for the response to arrive.
    const _handle = productHandle.replace(/^\/+/, '').split('?')[0];
    window._qaFetchCache = window._qaFetchCache || new Map();
    const _cachedText = window._qaFetchCache.get(_handle) || null;
    if (_cachedText) window._qaFetchCache.delete(_handle); // consume it

    productCard._quickAddFetchPromise = (_cachedText || fetch(productUrl, { cache: "force-cache", credentials: 'same-origin', priority: 'high' }).then((res) => res.text()))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const productHTML = doc.querySelector(`.grid__item[data-product-item="${productHandle}"]`);
        if (!productHTML) return;

        const label = productHTML.querySelector(".target-input")?.dataset.label || "";
        const variantMarkup = productHTML.querySelector(".card_varinats_width_quick_add")?.innerHTML || "";

        const targetContainer = productCard.querySelector(".card_varinats_width_quick_add");
        if (targetContainer) targetContainer.innerHTML = variantMarkup;

        const colorInput = singleColor.closest(".color_swatch_wraper")?.querySelector(".varinats_check_input_color");
        if (colorInput) colorInput.setAttribute("data-label", label);

        // Immediately apply stock unavailability to the freshly-injected variant HTML.
        // Without this, the new inputs have no unavailable_variant class even if the
        // cart already holds the last unit, because setUnavailable was only called
        // on the old DOM nodes that were just replaced.
        try {
          if (window.__QA && typeof window.__QA.refreshContainer === 'function') {
            window.__QA.refreshContainer(productCard);
          }
        } catch (e) {}

        // Signal Quick_Add.js that swatch data is ready; resolves the event-listener path.
        productCard.dispatchEvent(new Event("quickadd:ready", { bubbles: false }));
      })
      .catch((err) => console.log("Fetch error:", err))
      .finally(() => {
        productCard.dataset.quickaddPending = "0";
        productCard._quickAddFetchPromise = null;
      });
  }

  const isSwiper = productCard.querySelector(".card__inner")?.classList.contains("inner-slider-enabled") ?? false;
  const imageContainer = productCard.querySelector(".slide_imgs") || productCard.querySelector(".slide_imgs-swiper");
  const selectedImages = singleColor.querySelector(".selected-color-images .selcted_slide_imgs-wrapper");

  // Update price, badges, variants, sizes
  if (!singleColor.classList.contains("one-product-color")) {
    const priceHTML = singleColor.querySelector(".metafield-product-price")?.innerHTML || "";
    const variantHTML = singleColor.querySelector(".metafield-product-options")?.innerHTML || "";
    const badgesHTML = singleColor.querySelector(".metafield-product-badges")?.innerHTML || "";
    const sizesHTML = singleColor.querySelector(".metafield-products-sizes")?.innerHTML || "";

    const priceContainer = productCard.querySelector(".card-product-price");
    const badgeContainer = productCard.querySelector(".card-product-badges");
    const sizeContainer = productCard.querySelector(".main-product-sizes");
    const variantContainer = productCard.querySelector(".main_variants_color_wraper_card");

    if (priceContainer) priceContainer.innerHTML = priceHTML;
    // Only overwrite the visible badges when the selected color actually carries
    // badge markup. The .metafield-product-badges source block emits whitespace
    // (not an empty string) when a color has no badge, so we must TRIM before
    // deciding — otherwise we'd overwrite real badges with whitespace and the
    // badge would vanish (seen in Related Products / Recently Viewed).
    if (badgeContainer && badgesHTML && badgesHTML.trim() !== "") {
      badgeContainer.innerHTML = badgesHTML;
    }
    if (sizeContainer) sizeContainer.innerHTML = sizesHTML;
    if (variantContainer) variantContainer.innerHTML = variantHTML;
  }

  
  // Toggle SOLD OUT badge on the card based on the selected color/product availability
  (function () {
    const availableStr = singleColor.dataset.available;
    let isAvailable = true;

    if (availableStr !== undefined) {
      isAvailable = availableStr === "true";
    } else if (singleColor.dataset.qty !== undefined) {
      const qty = parseInt(singleColor.dataset.qty, 10);
      if (!Number.isNaN(qty)) isAvailable = qty > 0;
    }

    const soldoutBadges = productCard.querySelectorAll(".js-soldout-badge");
    soldoutBadges.forEach((el) => el.classList.toggle("hidden", isAvailable));
  })();

// Update main image and links
  const imgURL = singleColor.getAttribute("p-img");
  const productLink = singleColor.getAttribute("p-link");
  const productTitle = singleColor.getAttribute("data-title");

  const mainImage = productCard.querySelector(".main_p_img");
  if (mainImage) {
    mainImage.src = imgURL;
    mainImage.srcset = imgURL;
  }

  const linkElements = productCard.querySelectorAll(".main-product-link, .card-product-link");
  linkElements.forEach((link) => {
    link.href = productLink;
    if (link.classList.contains("card-product-link")) {
      link.textContent = productTitle;
    }
  });

  // Manage swiper or fallback image replacement
  if (isSwiper && imageContainer && selectedImages) {
    imageContainer.innerHTML = selectedImages.innerHTML;
    initializeSwiper(imageContainer, singleColor, productCard);
    // After a swatch click the cursor is still inside .card-wrapper, so the
    // pointerenter listener in collection-pagination.js never re-fires and
    // slideTo(1, 0) is never called — the new Swiper stays at slide 0.
    // Fix: if the card is already :hover, advance to slide 1 immediately.
    // Only advance to slide 1 on true pointer devices (desktop/mouse).
    // On touch devices the browser applies sticky :hover after a tap, so
    // productCard.matches(':hover') would return true on mobile and trigger
    // slideTo(1) immediately after the color swap — jumping to the second image.
    // The same (min-width:990px) and (hover:hover) and (pointer:fine) guard
    // used by collection-pagination.js correctly excludes all touch devices.
    if (
      productCard.matches &&
      productCard.matches(':hover') &&
      window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches
    ) {
      var sw = imageContainer._swiperInstance;
      if (sw && !sw.destroyed) sw.slideTo(1, 0);
    }
  } else {
    // Non-Swiper cards (inner-slider-disabled).
    // The previous version replaced the whole .media innerHTML with ALL of the
    // selected color's slides. Dawn positions EVERY direct child of .media as
    // position:absolute; inset:0 (base.css), so the injected slides stacked on
    // top of each other and the LAST image (e.g. image 4) painted on top
    // instead of the first — most visible on mobile. Fix: keep the
    // .media--hover-effect structure intact and simply repoint the existing
    // image(s) at the selected color. The primary image is already updated
    // above; here we also refresh the secondary (hover) image so it matches the
    // newly selected color on desktop.
    const colorImgs = singleColor.querySelectorAll(
      ".selected-color-images .selcted_slide_imgs-wrapper .swiper-wrapper img"
    );
    const mediaAnchor = productCard.querySelector(
      ".media.media--hover-effect > a.main-product-link.card-product-link-first"
    );
    if (mediaAnchor && colorImgs.length) {
      const imgs = mediaAnchor.querySelectorAll("img.main_p_img");
      if (imgs[0] && colorImgs[0]) {
        imgs[0].src = colorImgs[0].getAttribute("src");
        imgs[0].srcset =
          colorImgs[0].getAttribute("srcset") || colorImgs[0].getAttribute("src");
      }
      if (imgs[1] && colorImgs[1]) {
        imgs[1].src = colorImgs[1].getAttribute("src");
        imgs[1].srcset =
          colorImgs[1].getAttribute("srcset") || colorImgs[1].getAttribute("src");
      }
    }
  }

  // NOTE: the pointer-events toggle that used to be here has been removed.
  // Color swatches are in the lower card__content (a sibling of card__inner),
  // so the cursor is always OUTSIDE card__inner at the moment of a swatch click.
  // Setting pointer-events:none on card__inner created a ~16ms window that swallowed
  // the mouseenter event when the user moved back to the image area quickly, causing
  // the hover second-image to silently fail.  Without the toggle, mouseenter fires
  // normally as the cursor enters card__inner and CSS :hover is applied immediately.

  // Update swatch active state
  productCard.querySelectorAll(".color_product_main").forEach((swatch) => {
    swatch.classList.remove("active_color");
  });
  singleColor.classList.add("active_color");

  // Update color label for selected variant
  const colorName = singleColor.dataset.color;
  const checkedInput = singleColor.closest(".color_swatch_wraper")?.querySelector(".color_variants:checked");
  if (checkedInput) {
    checkedInput.setAttribute("data-label", colorName);
  }

  // Re-apply QA stock unavailability after synchronous DOM replacements.
  // Every swatch click replaces .main-product-sizes (and on mobile also
  // .card_varinats_width_quick_add) with server-rendered HTML that has no
  // unavailable_variant class. This call re-runs the check on the fresh nodes
  // using the already-populated qtyMap — no additional cart fetch is needed.
  // Must run after active_color is updated so resolveOptionForInput picks up
  // the newly selected color when building the variant lookup key.
  try {
    if (window.__QA && typeof window.__QA.refreshContainer === 'function') {
      window.__QA.refreshContainer(productCard);
    }
  } catch (e) {}
}

function initializeSwiper(container, singleColor, productCard) {
  if (container._swiperInstance) {
    container._swiperInstance.destroy(true, true);
    container._swiperInstance = null;
  }

  container._swiperInstance = new Swiper(container, {
    loop: false,
    spaceBetween: 3,
    initialSlide: 0,
    watchOverflow: false,
    breakpoints: { 990: { spaceBetween: 5, loop: false } },

    observer: true,
    observeParents: true,
    resizeObserver: true,

    navigation: {
      nextEl: productCard.querySelector(".swiper-button-next"),
      prevEl: productCard.querySelector(".swiper-button-prev"),
    },
    scrollbar: { el: productCard.querySelector(".swiper-scrollbar"), hide: true },
        on: {
  init(swiper) {
    swiper.slideTo(0, 0);
  },
  breakpoint(swiper) {
    swiper.slideTo(0, 0);
  }
},
  });

container._swiperInstance.on("slideChangeTransitionStart", () => {
  const mainScrollbar = productCard.querySelector(".swiper-scrollbar");
  const swatchScrollbar = singleColor?.querySelector(".swiper-scrollbar");

  if (mainScrollbar) {
    mainScrollbar.style.opacity = "0.7";
    if (swatchScrollbar) swatchScrollbar.style.opacity = "0.7";

    const drag = mainScrollbar.querySelector(".swiper-scrollbar-drag");
    if (drag) drag.style.background = "rgba(0,0,0,0.5)";

    clearTimeout(mainScrollbar._flashT);
    mainScrollbar._flashT = setTimeout(() => {
      mainScrollbar.style.opacity = "0";
      if (swatchScrollbar) swatchScrollbar.style.opacity = "0";
    }, 2000);
  }
});
}
window.initializeSwiper = initializeSwiper;


function active_colors() {
  document.querySelectorAll(".active_color").forEach((el) => el.click());
}


// complete the look pdp
var ctlContainer = document.querySelector(".product-metafield-addons");
if (ctlContainer) {
  var ctlSizeSelects = ctlContainer.querySelectorAll("select");
  ctlSizeSelects.forEach((ctlSizeSelect) => {
    ctlSizeSelect.addEventListener("change", () => {
      var addonContainer = ctlSizeSelect.closest(".addon-product-item");
      addonContainer.querySelector("button").removeAttribute("disabled");
      var addonSelectedSize = ctlSizeSelect.value;
      ctlSizeSelect.closest("form").querySelector('[name="id"]').value =
        addonSelectedSize;

      var selectedOption = ctlSizeSelect.options[ctlSizeSelect.selectedIndex];
      var addonVariantPrice = selectedOption.getAttribute("data-price");
      var addonVariantPriceCompare =
        selectedOption.getAttribute("data-compare-price");
      addonContainer.querySelector(
        ".addon-product-price .addon-sale-price"
      ).innerHTML = addonVariantPrice;
      if (
        addonContainer.querySelector(
          ".addon-product-price .addon-compare-price"
        )
      ) {
        addonContainer.querySelector(
          ".addon-product-price .addon-compare-price"
        ).innerHTML = addonVariantPriceCompare;
      }
    });
  });

  var addonATCBtns = ctlContainer.querySelectorAll("button");
  if (addonATCBtns) {
    addonATCBtns.forEach((addonATCBtn) => {
      addonATCBtn.addEventListener("click", (e) => {
        e.preventDefault();

        addonATCBtn.textContent = "Adding...";

        var data = {
          id: addonATCBtn.closest("form").querySelector('[name="id"]').value,
          quantity: 1,
        };
        var atc_url = "/cart/add.js";

        fetch(atc_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to add item to cart");
            } else {
              return response.json();
            }
          })
          .then((data) => {
            var cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              fetch(window.location.href)
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(
                      "Network response was not ok " + response.statusText
                    );
                  }
                  return response.text();
                })
                .then((html) => {
                  // Parse the fetched HTML and extract the content you want to update
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, "text/html");
                  const newContent = doc.getElementById("CartDrawer").innerHTML;
                  const newCount =
                    doc.querySelector(".cart-count-bubble").innerHTML;

                  // Update the content of the page without a full reload
                  document.getElementById("CartDrawer").innerHTML = newContent;
                  if (document.querySelector(".cart-count-bubble")) {
                    document.querySelector(".cart-count-bubble").innerHTML =
                      newCount;
                  }
                  document
                    .querySelector("body")
                    .classList.add("overflow-hidden");
                  cartDrawer.classList.add("active", "animate");
                  addonATCBtn.textContent = "Add";
                  var emptyCart = (document
                    .getElementById("CartDrawer")
                    .querySelector(
                      ".cart__contents.cart-drawer__form"
                    ).style.display = "block");
                  var drawerOverlay = document.querySelector(
                    ".cart-drawer__overlay"
                  );
                  if (drawerOverlay) {
                    drawerOverlay.addEventListener("click", (e) => {
                      document
                        .getElementById("CartDrawer")
                        .querySelector(".drawer__close")
                        .click();
                    });
                  }
                })
                .catch((error) => {
                  console.error(
                    "There was a problem with the fetch operation:",
                    error
                  );
                });
            }
          })
          .catch((error) => {
            console.error("Error in adding to cart", error);
          });
      });
    });
  }
}

// active pdp color
var colorProductsContainer = document.querySelector(".color-radio-buttons");
if (colorProductsContainer) {
  var activeColorProduct = colorProductsContainer.querySelector(
    "a.main-swatch-color-product.active"
  );
  if (activeColorProduct) {
    var activeColorProductName =
      activeColorProduct.getAttribute("data-color-display");
    // activeColorProductName = activeColorProductName.replace(/-/g, ' ');
    document.querySelector(".selected-product-color").textContent =
      activeColorProductName;
  }
}
// on mobile close zoom image
// document.addEventListener("click", function (event) {
//   var topBar = event.target.closest(".pswp__item"); // Check if the click is inside topBar

//   if (topBar) {

//     // Find all close buttons inside the same `.pswp` modal
//     var closeButtons = document.querySelectorAll(".pswp__button--close");


//     if (closeButtons.length > 0) {
//       closeButtons.forEach((button) => button.click());
//     }
//   }
// });
//  according screen size color switches
function updateProductDisplay() {
  const containers = document.querySelectorAll('.product_meta_colors.desktop');
  if (!containers.length) return;

  containers.forEach((container) => {
    const colorItems = container.querySelectorAll('.color_product_main');
    if (!colorItems.length) return;

    let visibleCount = 0;

    colorItems.forEach((el) => {
      const style = window.getComputedStyle(el);
      if (style.display !== 'none') {
        visibleCount++;
      }
    });

    const totalCount = colorItems.length;
    const extraCount = Math.max(0, totalCount - visibleCount);

    let extraCountLink = container.querySelector('.extra_color_count');

    if (!extraCountLink) {
      extraCountLink = document.createElement('a');
      extraCountLink.className = 'extra_color_count';
      const cardLink = container.closest('.card-wrapper')?.querySelector('a.card-product-link');
      extraCountLink.href = cardLink
        ? cardLink.getAttribute('href')
        : (container.querySelector('.color_product_main[p-link]')?.getAttribute('p-link') || window.location.href);
      container.appendChild(extraCountLink);
    }

    if (extraCount > 0) {
      if (!extraCountLink.querySelector('.ec-count')) {   // keep the responsive server spans
        extraCountLink.textContent = `+${extraCount}`;
      }
      extraCountLink.style.display = 'inline-block';
    } else {
      extraCountLink.style.display = 'none';
    }
  });
}

document.addEventListener("DOMContentLoaded", updateProductDisplay);
window.addEventListener('resize', updateProductDisplay);

// =============================
// COMPLETE THE FIT – Cart addons
// =============================
document.addEventListener("DOMContentLoaded", function () {
  function markUnavailableAddonSizes() {
    document.querySelectorAll(".cart-addon-card__size-btn").forEach(function (btn) {
      var availableAttr = btn.getAttribute("data-available");
      var isAvailable =
        !(
          availableAttr === "false" ||
          availableAttr === "0" ||
          availableAttr === "unavailable"
        ) && !btn.classList.contains("is-unavailable");

      if (!isAvailable) {
        btn.classList.add("is-unavailable");
        btn.setAttribute("aria-disabled", "true");
      }
    });
  }

  function updateAddonCardsVisibility(cart) {
    document.querySelectorAll(".cart-addons").forEach(function (wrapper) {
      var cards = wrapper.querySelectorAll(".cart-addon-card");

      if (!cart || !cart.items || !cards.length) {
        wrapper.style.display = "none";
        return;
      }

      var productIdsInCart = cart.items.map(function (item) {
        return item.product_id;
      });

      var visibleCount = 0;

      cards.forEach(function (card) {
        var addonProductId = Number(card.getAttribute("data-addon-product-id"));
        var inCart = addonProductId && productIdsInCart.indexOf(addonProductId) !== -1;

        card.style.display = inCart ? "none" : "";
        if (!inCart) visibleCount++;
      });

      wrapper.style.display = visibleCount ? "" : "none";
    });
  }

function refreshCartAddonsFromCart() {
  fetch("/cart.js")
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateAddonCardsVisibility(cart);

      document.querySelectorAll(".cart-addons").forEach(function (wrapper) {
        updateCartAddonsArrows(wrapper);
      });
    })
    .catch(function (err) {
      console.error("Error reading cart for addons:", err);
    });
}

function updateCartAddonsArrows(wrapper) {
  if (!wrapper) return;
  var track = wrapper.querySelector(".cart-addons__track");
  var prevBtn = wrapper.querySelector(".cart-addons__arrow--prev");
  var nextBtn = wrapper.querySelector(".cart-addons__arrow--next");
  if (!track || !prevBtn || !nextBtn) return;

  // Only count visible cards (display:none cards are not part of the slider)
  var visibleCards = Array.prototype.slice.call(
    track.querySelectorAll(".cart-addon-card")
  ).filter(function (card) {
    if (!card) return false;
    if (card.offsetParent === null) return false;
    var cs = window.getComputedStyle(card);
    return cs && cs.display !== "none" && cs.visibility !== "hidden";
  });

  // If there's 0-1 visible addon, there's no "next/prev" state to show
  if (visibleCards.length <= 1) {
    prevBtn.classList.add("cart-addons__arrow--disabled");
    nextBtn.classList.add("cart-addons__arrow--disabled");
    prevBtn.setAttribute("aria-disabled", "true");
    nextBtn.setAttribute("aria-disabled", "true");
    return;
  }

  var canScroll = track.scrollWidth - track.clientWidth > 2;

  if (!canScroll) {
    prevBtn.classList.add("cart-addons__arrow--disabled");
    nextBtn.classList.add("cart-addons__arrow--disabled");
    prevBtn.setAttribute("aria-disabled", "true");
    nextBtn.setAttribute("aria-disabled", "true");
    return;
  }

  var maxScrollLeft = track.scrollWidth - track.clientWidth - 1;
  var atStart = track.scrollLeft <= 1;
  var atEnd = track.scrollLeft >= maxScrollLeft;

  prevBtn.classList.toggle("cart-addons__arrow--disabled", atStart);
  nextBtn.classList.toggle("cart-addons__arrow--disabled", atEnd);
  prevBtn.setAttribute("aria-disabled", atStart ? "true" : "false");
  nextBtn.setAttribute("aria-disabled", atEnd ? "true" : "false");
}

  function attachOverlayListener() {
    var drawerOverlay = document.querySelector(".cart-drawer__overlay");
    if (!drawerOverlay) return;

    drawerOverlay.onclick = function () {
      var closeBtn = document.querySelector("#CartDrawer .drawer__close");
      if (closeBtn) closeBtn.click();
    };
  }

  initCartAddonsObserver();

  // Keep arrows state correct when CartDrawer HTML gets re-rendered (Shopify replaces #CartDrawer innerHTML)
function scheduleCartAddonsArrowsUpdate() {
  if (scheduleCartAddonsArrowsUpdate._raf) {
    cancelAnimationFrame(scheduleCartAddonsArrowsUpdate._raf);
  }
  // Double-RAF: first frame lets the browser apply any pending style changes,
  // second frame runs after a full layout pass — enough for most drawer animations.
  scheduleCartAddonsArrowsUpdate._raf = requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      document.querySelectorAll(".cart-addons").forEach(function (wrapper) {
        updateCartAddonsArrows(wrapper);
      });
    });
  });
  // 300ms fallback timer catches cases where the drawer CSS transition
  // (typically ~200ms) hasn't finished by the time the double-RAF fires.
  if (scheduleCartAddonsArrowsUpdate._timer) {
    clearTimeout(scheduleCartAddonsArrowsUpdate._timer);
  }
  scheduleCartAddonsArrowsUpdate._timer = setTimeout(function () {
    document.querySelectorAll(".cart-addons").forEach(function (wrapper) {
      updateCartAddonsArrows(wrapper);
    });
  }, 300);
}

function initCartAddonsObserver() {
  var target = document.getElementById("CartDrawer");
  if (!target || target.__cartAddonsObserverBound) return;
  target.__cartAddonsObserverBound = true;

  // MutationObserver handles re-renders while the drawer is already open
  // (e.g. Shopify replaces #CartDrawer innerHTML after an add-to-cart).
  // Guard: only fire when the drawer is actually open, so we don't measure
  // layout while the panel is off-screen (transform: translateX(100%)).
  var obs = new MutationObserver(function () {
    var cartDrawerEl = document.querySelector("cart-drawer");
    if (cartDrawerEl && cartDrawerEl.classList.contains("active")) {
      scheduleCartAddonsArrowsUpdate();
    }
  });

  obs.observe(target, { childList: true, subtree: true });

  // Fire arrow update exactly when the drawer finishes its open animation.
  // The drawer hides via transform: translateX(100%), NOT display:none —
  // so clientWidth is always > 0 and timing-based guards are unreliable.
  // transitionend on .drawer__inner for the "transform" property fires at the
  // precise moment when layout is stable, visible, and scroll metrics are correct.
  var drawerInner = document.querySelector(".drawer__inner");
  if (drawerInner && !drawerInner.__cartAddonsTransitionBound) {
    drawerInner.__cartAddonsTransitionBound = true;
    drawerInner.addEventListener("transitionend", function (e) {
      if (e.propertyName !== "transform") return;
      var cartDrawerEl = document.querySelector("cart-drawer");
      // Only act on open (not close): cart-drawer has "active" when open
      if (!cartDrawerEl || !cartDrawerEl.classList.contains("active")) return;
      document.querySelectorAll(".cart-addons").forEach(function (wrapper) {
        updateCartAddonsArrows(wrapper);
      });
    });
  }
  // Do NOT call scheduleCartAddonsArrowsUpdate() here: the drawer is closed at
  // page load, measuring scroll metrics on a transformed-off-screen panel gives
  // wrong results (scrollWidth may equal clientWidth before full layout is committed).
}

document.addEventListener("click", function (event) {
  var prevBtn = event.target.closest(".cart-addons__arrow--prev");
  var nextBtn = event.target.closest(".cart-addons__arrow--next");
  var btn = prevBtn || nextBtn;
  if (!btn) return;

  if (btn.classList.contains("cart-addons__arrow--disabled")) {
    return;
  }

  var wrapper = btn.closest(".cart-addons");
  if (!wrapper) return;

  var track = wrapper.querySelector(".cart-addons__track");
  if (!track) return;

var cards = Array.prototype.slice.call(
  track.querySelectorAll(".cart-addon-card")
).filter(function (card) {
  if (!card) return false;
  if (card.offsetParent === null) return false;
  var cs = window.getComputedStyle(card);
  return cs && cs.display !== "none" && cs.visibility !== "hidden";
});
  if (!cards.length) return;

  var step;
  if (cards.length >= 2) {
    var firstLeft = cards[0].offsetLeft;
    var secondLeft = cards[1].offsetLeft;
    step = secondLeft - firstLeft;
  } else {
    step = cards[0].getBoundingClientRect().width;
  }

  if (step <= 0) return;

  var currentIndex = Math.round(track.scrollLeft / step);

  var visibleCount = Math.max(1, Math.round(track.clientWidth / step));

  var maxIndex = Math.max(0, cards.length - visibleCount);

  var dir = prevBtn ? -1 : 1;
  var targetIndex = currentIndex + dir;

  if (targetIndex < 0) targetIndex = 0;
  if (targetIndex > maxIndex) targetIndex = maxIndex;

  var targetScrollLeft = targetIndex * step;

  var maxScrollLeft = track.scrollWidth - track.clientWidth;
  if (targetScrollLeft > maxScrollLeft) {
    targetScrollLeft = maxScrollLeft;
  }
  if (targetScrollLeft < 0) {
    targetScrollLeft = 0;
  }

  track.scrollTo({
    left: targetScrollLeft,
    behavior: "smooth",
  });

  setTimeout(function () {
    updateCartAddonsArrows(wrapper);
  }, 350);
});

  document.addEventListener(
    "scroll",
    function (event) {
      var track = event.target;
      if (track && track.classList && track.classList.contains("cart-addons__track")) {
        var wrapper = track.closest(".cart-addons");
        if (wrapper) updateCartAddonsArrows(wrapper);
      }
    },
    true
  );

  // =========================
  // + ADD
  // =========================
  document.addEventListener("click", function (event) {
    var addBtn = event.target.closest(".cart-addon-card__add-btn");
    if (addBtn) {
      var card = addBtn.closest(".cart-addon-card");
      if (!card) return;
      var sizes = card.querySelector(".cart-addon-card__sizes");
      if (!sizes) return;

      addBtn.classList.add("is-hidden");
      sizes.hidden = false;
      sizes.classList.add("is-visible");
      return;
    }

var sizeBtn = event.target.closest(".cart-addon-card__size-btn");
if (sizeBtn) {
  if (sizeBtn.classList.contains("is-unavailable")) return;

  var variantId = sizeBtn.getAttribute("data-variant-id");
  if (!variantId) return;

  var card = sizeBtn.closest(".cart-addon-card");
  var loader = card && card.querySelector(".cart-addon-card__loader");

  if (card) {
    card
      .querySelectorAll(".cart-addon-card__size-btn")
      .forEach(function (btn) {
        btn.classList.toggle("is-active", btn === sizeBtn);
      });
  }

  if (loader) loader.style.display = "flex";

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
  })
    .then(function (res) {
      return res.json();
    })
    .then(function () {
      if (card) {
        if (loader) loader.style.display = "none";

        var imageWrapper = card.querySelector(
          ".cart-addon-card__image-wrapper"
        );
        if (imageWrapper) {
          var check = card.querySelector(
            ".cart-addon-card__added-check"
          );
if (!check) {
  check = document.createElement("div");
  check.className = "cart-addon-card__added-check";

  check.innerHTML = `
    <svg class="add-success--tick lds-ring2"
         viewBox="0 0 40 40"
         xmlns="http://www.w3.org/2000/svg">
      <polyline
        points="11.6,20 15.9,24.2 26.4,13.8"
        fill="none"
        stroke="rgba(18,18,18,1)"
        stroke-width="2.5px" />
    </svg>
  `;

  imageWrapper.appendChild(check);
}
          check.classList.add("is-visible");
        }

        var wrapper = card.closest(".cart-addons");

        setTimeout(function () {
          card.remove();
          if (
            wrapper &&
            !wrapper.querySelector(".cart-addon-card")
          ) {
            wrapper.style.display = "none";
          }

          reloadCartDrawerFromServer();
          refreshCartAddonsFromCart();
        }, 800);

        return;
      }

      reloadCartDrawerFromServer();
      refreshCartAddonsFromCart();
    })
    .catch(function (err) {
      console.error("Error adding addon to cart:", err);
    })
    .finally(function () {
      if (loader) loader.style.display = "none";
    });

  return;
}

  // =========================
  // Loader
  // =========================
  var qtyBtn = event.target.closest(
    ".quantity__button, button[name='plus'], button[name='minus']"
  );

  if (qtyBtn) {
    var row = qtyBtn.closest(".cart-item");
    if (row) {
      var media = row.querySelector(".cart-item__media");
      if (media) {
        var loader = media.querySelector(".cart-item__loader");

        if (!loader) {
          loader = document.createElement("div");
          loader.className = "cart-item__loader";
          loader.innerHTML = "<span></span><span></span><span></span>";
          media.appendChild(loader);
        }

        loader.style.display = "flex";

        setTimeout(function () {
          if (loader && loader.style.display === "flex") {
            loader.style.display = "none";
          }
        }, 2000);
      }
    }
  }

  // =========================
  // Loader
  // =========================

  var minusBtn = event.target.closest('.quantity__button[name="minus"]');
  if (minusBtn) {
    var cartItem = minusBtn.closest(".cart-item");
    if (!cartItem) return;

    var qtyInput = cartItem.querySelector(".quantity__input, input[name='updates[]']");
    if (!qtyInput) return;

    var originalQtyAttr = qtyInput.getAttribute("value");
    var originalQty = parseInt(originalQtyAttr, 10);

    if (isNaN(originalQty)) {
      originalQty = parseInt(qtyInput.value, 10) || 0;
    }

    if (originalQty === 1) {
      event.preventDefault();
      event.stopPropagation();

      var removeBtnInRow = cartItem.querySelector(".cart-remove-button");
      if (removeBtnInRow) {
        removeBtnInRow.click();
      }

      return;
    }
  }
  
  var removeBtn = event.target.closest(".cart-remove-button");
  if (removeBtn) {
    var row = removeBtn.closest(".cart-item");
    if (row) {
      var media = row.querySelector(".cart-item__media");
      if (media) {
        var loader = media.querySelector(".cart-item__loader");

        if (!loader) {
          loader = document.createElement("div");
          loader.className = "cart-item__loader";
          loader.innerHTML = "<span></span><span></span><span></span>";
          media.appendChild(loader);
        }

        loader.style.display = "flex";

        setTimeout(function () {
          if (loader && loader.style.display === "flex") {
            loader.style.display = "none";
          }
        }, 2000);
      }
    }

    setTimeout(refreshCartAddonsFromCart, 400);
  }

  });

  markUnavailableAddonSizes();
  refreshCartAddonsFromCart();
  document.querySelectorAll(".cart-addons").forEach(function (wrapper) {
    updateCartAddonsArrows(wrapper);
  });
  attachOverlayListener();

  document.addEventListener("cart:drawer:updated", function () {
    markUnavailableAddonSizes();
    refreshCartAddonsFromCart();
    document.querySelectorAll(".cart-addons").forEach(function (wrapper) {
      updateCartAddonsArrows(wrapper);
    });
    attachOverlayListener();
  });
});
function reloadCartDrawerFromServer() {
  var cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  // Fetch ONLY the cart-drawer section (much faster than fetching the full page HTML)
  var url = new URL(window.location.pathname, window.location.origin);
  url.searchParams.set("sections", "cart-drawer");
  url.searchParams.set("cb", Date.now());

  return fetch(url.toString(), { cache: "no-store" })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      return response.json();
    })
    .then(function (data) {
      var sectionHtml = data && (data["cart-drawer"] || data["cart_drawer"] || data["CartDrawer"]);
      if (!sectionHtml) return;

      var parser = new DOMParser();
      var doc = parser.parseFromString(sectionHtml, "text/html");
      var drawerEl = doc.getElementById("CartDrawer");
      if (!drawerEl) return;

      var newContent = drawerEl.innerHTML;
      var liveDrawer = document.getElementById("CartDrawer");
      if (!liveDrawer) return;

      liveDrawer.innerHTML = newContent;

      // Open drawer (same behavior as before)
      cartDrawer.classList.add("mbl_drawer");
      cartDrawer.classList.add("active", "animate");
      cartDrawer.classList.remove("is-empty");

      var innerEmpty = cartDrawer.querySelector(".drawer__inner-empty");
      var contents = cartDrawer.querySelector(".cart__contents.cart-drawer__form");

      if (innerEmpty) innerEmpty.classList.add("hidden");
      if (contents) contents.style.display = "block";

      document.body.classList.add("overflow-hidden");

      // Refresh cart totals/bubbles in background
      return fetch("/cart.js", { cache: "no-store" });
    })
    .then(function (res) {
      if (!res) return;
      return res.json();
    })
    .then(function (cart) {
      if (!cart) return;

      var bubbles = document.querySelectorAll(".cart-count-bubble");
      bubbles.forEach(function (bubble) {
        var span = bubble.querySelector('span[aria-hidden="true"]');
        if (!span) return;

        span.textContent = cart.item_count;

        if (cart.item_count > 0) {
          bubble.classList.remove("cart-count-0");
        } else {
          bubble.classList.add("cart-count-0");
        }
      });

      if (typeof updateFreeShippingBar === "function") {
        updateFreeShippingBar(cart.total_price);
      }

      try {
        document.dispatchEvent(
          new CustomEvent("cart:drawer:updated", { detail: { cart: cart } })
        );
      } catch (e) {
        document.dispatchEvent(new Event("cart:drawer:updated"));
      }
    })
    .catch(function (error) {
      console.error("Error reloading CartDrawer:", error);
      // audit M7 — drawer HTML may already be swapped; fire the event anyway so
      // overlay-close re-binding and other listeners recover even if /cart.js fails.
      try { document.dispatchEvent(new Event("cart:drawer:updated")); } catch (e) {}
    });
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.__quickAddListenersBound) return;
  window.__quickAddListenersBound = true;
  
  mobilePopup();
  hideQuickAdd();
  markUnavailableSizesInCards();
  try {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var activeColor = card.querySelector('.color_product_main.active_color') 
                     || card.querySelector('.color_product_main');
      if (activeColor && !activeColor.classList.contains('active_color')) {
        activeColor.classList.add('active_color');
      }
    });
  } catch (e) {}
});

// Re-run SliderComponent layout after first paint so section-level carousel
// arrows are correctly enabled when initPages() ran before CSS grid was settled.
document.addEventListener("DOMContentLoaded", function () {
  requestAnimationFrame(function () {
    document.querySelectorAll("slider-component").forEach(function (el) {
      if (typeof el.reinitialize === "function") el.reinitialize();
    });
  });
});

function __rerunCollectionInit() {
  try { markUnavailableSizesInCards(); } catch (e) {}
  try { checkVariants(); } catch (e) {}
  try {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var activeColor = card.querySelector('.color_product_main.active_color')
                     || card.querySelector('.color_product_main');
      if (activeColor && !activeColor.classList.contains('active_color')) {
        activeColor.classList.add('active_color');
      }
    });
  } catch (e) {}
  try { if (typeof window.qaPrefetchCart === 'function') window.qaPrefetchCart(); } catch (e) {}
}

window.__rerunCollectionInit = __rerunCollectionInit;

document.addEventListener("collection:loadmore:appended", __rerunCollectionInit);

document.addEventListener("cart:drawer:updated", __rerunCollectionInit);

try {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, __rerunCollectionInit);
  }
} catch (e) {}


(function () {
  var drawerDetails = document.getElementById("Details-menu-drawer-container");
  if (!drawerDetails) return;
  var drawerSummary = drawerDetails.querySelector("summary");
  if (!drawerSummary) return;

  drawerSummary.addEventListener("click", function (e) {
    if (!drawerDetails.hasAttribute("open")) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    drawerSummary.setAttribute("aria-expanded", "false");
    drawerDetails.removeAttribute("open");
    drawerDetails.classList.remove("menu-opening");
    document.body.classList.remove("overflow-hidden-tablet");
    document.body.classList.remove("overflow-hidden-desktop");
    var header = document.querySelector(".section-header");
    if (header) header.classList.remove("menu-open");
  }, true);
})();

/* Extra colors (+N) — Mode B slider + edge fade + left/right scroll arrows (desktop + mobile), vertically centered on the swatch row. */
(function () {
  var CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
  var CHEVRON_LEFT  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"></polyline></svg>';

  function pinWidth(container) {
    var stop = container.closest(".grid__item") || container.closest(".card-wrapper");
    var node = container;
    while (node) { node.style.minWidth = "0"; if (node === stop) break; node = node.parentElement; }
    var box = container.closest(".card-information, .card__information, .card__content") ||
              container.closest(".card-wrapper") || container.parentElement;
    if (box) {
      var cs = getComputedStyle(box);
      var avail = box.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
      if (avail > 0) container.style.maxWidth = Math.floor(avail) + "px";
    }
  }

  /* Furthest we ever want to scroll: the right edge of the LAST real swatch minus
     the viewport width. Prevents landing in any empty space after the swatches. */
  function maxUsefulScroll(container) {
    var swatches = container.querySelectorAll(".color_product_main");
    if (!swatches.length) return 0;
    var last = swatches[swatches.length - 1];
    var cRect = container.getBoundingClientRect();
    var lRect = last.getBoundingClientRect();
    var lastRight = (lRect.right - cRect.left) + container.scrollLeft;
    var padRight = parseFloat(getComputedStyle(container).paddingRight) || 0;
    return Math.max(0, Math.ceil(lastRight + padRight - container.clientWidth));
  }

  function makeArrow(cls, label, svg, container, dir) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ec-slider-arrow " + cls;
    btn.setAttribute("aria-label", label);
    btn.innerHTML = svg;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var step = Math.round(container.clientWidth * 0.8);
      var target = container.scrollLeft + (dir * step);
      target = Math.max(0, Math.min(target, maxUsefulScroll(container)));
      container.scrollTo({ left: target, behavior: "smooth" });
    });
    return btn;
  }

  function ensureChrome(container) {
    var wrap = container.parentElement;
    if (!wrap || !wrap.classList.contains("ec-slider-wrap")) {
      wrap = document.createElement("div");
      wrap.className = "ec-slider-wrap";
      container.parentNode.insertBefore(wrap, container);
      wrap.appendChild(container);
    }
    /* Arrows are siblings of the container, so they can't inherit the CSS vars set
       on it. Copy the arrow style vars up onto the wrap (their real parent). */
    ["--sw-arrow-bg", "--sw-arrow-x", "--sw-arrow-y", "--sw-arrow-radius", "--sw-arrow-size", "--sw-arrow-padding"].forEach(function (v) {
      var val = container.style.getPropertyValue(v);
      if (val) wrap.style.setProperty(v, val);
    });
    if (!wrap.querySelector(".ec-slider-arrow--left")) {
      wrap.appendChild(makeArrow("ec-slider-arrow--left", "Scroll colors left", CHEVRON_LEFT, container, -1));
    }
    if (!wrap.querySelector(".ec-slider-arrow--right")) {
      wrap.appendChild(makeArrow("ec-slider-arrow--right", "Scroll colors right", CHEVRON_RIGHT, container, 1));
    }
    return wrap;
  }

  /* Center the arrows on the actual swatch row, not on the whole wrapper. */
  function positionArrows(container, wrap) {
    wrap = wrap || container.parentElement;
    if (!wrap) return;
    var swatch = container.querySelector(".color_product_main");
    if (!swatch) return;
    var center = swatch.offsetTop + (swatch.offsetHeight / 2);
    wrap.style.setProperty("--sw-arrow-center", center + "px");
  }

  function refresh(container) {
    var maxS = maxUsefulScroll(container);
    container.classList.toggle("is-scrollable", maxS > 1);
    container.classList.toggle("at-start", container.scrollLeft <= 1);
    container.classList.toggle("at-end", container.scrollLeft >= maxS - 1);
  }

  document.addEventListener("click", function (e) {
    var pill = e.target.closest(".extra_color_count");
    if (!pill) return;
    var container = pill.closest(".product_meta_colors");
    if (!container) return;
    if ((container.getAttribute("data-extra-mode") || "a").toLowerCase() !== "b") return;

    e.preventDefault();
    e.stopPropagation();
    container.classList.add("is-expanded");

    requestAnimationFrame(function () {
      pinWidth(container);
      var wrap = ensureChrome(container);
      positionArrows(container, wrap);
      refresh(container);
      if (!container.dataset.ecScrollBound) {
        container.dataset.ecScrollBound = "1";
        container.addEventListener("scroll", function () { refresh(container); }, { passive: true });
      }
    });
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll(".product_meta_colors.is-expanded").forEach(function (container) {
      pinWidth(container);
      positionArrows(container);
      refresh(container);
    });
  });
})();